import React, { useContext, useRef } from "react";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";
import "./product.css";
import ProductBanner from "../../Components/Product/ProductBanner";
import BenefitSectionPlanPage from "../../Components/BenefitsSectionPlanPage";
import PricingSectionHome from "../../Components/PricingSectionHome/PricingSectionHome";
import HealthServices from "../../Components/HealthServices";
import CapsuleSlider from "../../Components/CapsuleSlider";
import WellnessHero from "../../Components/WellnessHero";
import BenefitsSection from "../../Components/BenefitdSection";
import UpgradeNetwork from "../../Components/UpgradeNetwork";
import FAQs from "../../Components/FAQs";
import FAQsMobile from "../../Components/FAQsIndexaMobile";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";

import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";

import CoverImage from "../../Assets/Images/UniverseIndexProduct-image.png";
import CoverMobileImage from "../../Assets/Images/UniverseIndexProduct-mobile-image.png";
import IndexedAccountCoverImage from "../../Assets/Images/Indexed-New-1280.png";
import IndexedAccountMobileImage from "../../Assets/Images/Indexed-New-768.png";
import IndexedUniversalProductImage from "../../Assets/Images/Indexed Universal Product.png";
import SliderSection from "../../Components/SliderSection";
import NavBar from "../../Components/NavBar";
import desktopImage from "../../Assets/Images/product-banner-3.png";
import mobileImage from "../../Assets/Images/product-banner-3-mobile.png";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";

import FixedAccountIcon from "../../Assets/Images/fixed-account-icon.png";
import IndexedAccountIcon from "../../Assets/Images/indexed-account-icon.svg";

import BenefitRiderIcon1 from "../../Assets/Images/benefit-rider-blue-icon1.svg";
import BenefitRiderIcon2 from "../../Assets/Images/benefit-rider-icon2.svg";
import BenefitRiderIcon3 from "../../Assets/Images/benefit-rider-icon3.svg";
import BenefitRiderIcon4 from "../../Assets/Images/benefit-rider-blue-icon4.svg";
import BenefitRiderIcon5 from "../../Assets/Images/benefit-rider-icon5.svg";
import BenefitRiderMobileIcon4 from "../../Assets/Images/benefit-rider-blue-icon4.svg";
import BenefitRiderMobileIcon1 from "../../Assets/Images/benefit-rider-blue-icon1.svg";

import BenefitsImage from "../../Assets/Images/account-value-img.png";
import BenefitsIcon1 from "../../Assets/Images/premiums-icon.svg";
import BenefitsIcon2 from "../../Assets/Images/interest-icon.svg";
import BenefitsIcon3 from "../../Assets/Images/deduction-icon.svg";
import BenefitsIcon4 from "../../Assets/Images/other-deduction-icon.svg";
import BenefitsRightArrowIcon from "../../Assets/Images/right-arrow.svg";
import BenefitsleftArrowIcon from "../../Assets/Images/left-arrow.svg";
import AccountValueIcon from "../../Assets/Images/account-value-icon.svg";

import UniversalType1 from "../../Assets/Images/universal-type1.svg";

import BenefitsMobileImage from "../../Assets/Images/account-value-mobile-img.png";

import HomeOverlayMobileElement3 from "../../Assets/Images/universe-overlay-element-mobile-1.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/universe-overlay-element-mobile-2.png";

import { LanguageContext } from "../../Hooks/langugaeContext";
import { TransEn, TransEs } from "../../constants/HomeBannerConst";
import { motion } from "framer-motion";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const IndexedUniversalLifeInsurance = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();
  // language translation code
  // const { language } = useContext(LanguageContext);
  // const translations = language === "Eng" ? TransEn : TransEs;

  const scrollToRef = useRef(null);
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const listItems = [
    {
      y: "30%",
      rotate: 3,
      bgColor: "bg-[#F7F6F2]",
      icon: BenefitRiderIcon1,
      mobileIcon: BenefitRiderMobileIcon1,
      heading: translations.indexaBenefits.benefitsOptions.options1_title,
      content: translations.indexaBenefits.benefitsOptions.options1_Desc,
    },
    {
      y: "40%",
      rotate: 4,
      bgColor: "bg-[#D8ECED]",
      icon: BenefitRiderIcon2,
      mobileIcon: BenefitRiderIcon2,
      heading: translations.indexaBenefits.benefitsOptions.options2_title,
      content: translations.indexaBenefits.benefitsOptions.options2_Desc,
    },
    {
      y: "50%",
      rotate: 5,
      bgColor: "bg-[#FFF4D8]",
      icon: BenefitRiderIcon4,
      mobileIcon: BenefitRiderMobileIcon4,
      heading: translations.indexaBenefits.benefitsOptions.options3_title,
      content: translations.indexaBenefits.benefitsOptions.options3_Desc,
    },
    {
      y: "60%",
      rotate: 6,
      bgColor: "bg-[#D8ECED]",
      icon: BenefitRiderIcon5,
      mobileIcon: BenefitRiderIcon5,
      heading: translations.indexaBenefits.benefitsOptions.options4_title,
      content: translations.indexaBenefits.benefitsOptions.options4_Desc,
    },
    {
      y: "70%",
      rotate: 7,
      bgColor: "bg-[#F7F6F2] lg:bg-[#F7F6F2]",
      icon: BenefitRiderIcon3,
      mobileIcon: BenefitRiderIcon3,
      heading: translations.indexaBenefits.benefitsOptions.options5_title,
      content: translations.indexaBenefits.benefitsOptions.options5_Desc,
    },
  ];

  return (
    <>
      <NavBar />
      <section className="home-welcome  IndexedUniversed-banner container-fluid relative">
        <div className="IndexedUniversed-overlay-bg md:hidden lg:block"></div>
        <div className="home-welcome-overlay-element">
          <div className="absolute w-full h-full z-[4] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one hidden md:block"
              src={HomeOverlayElement2}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one block md:hidden"
              src={HomeOverlayMobileElement3}
            />
          </div>
          <div className="absolute w-full h-full z-[4] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two hidden md:block"
              src={HomeOverlayElement3}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two block md:hidden"
              src={HomeOverlayMobileElement2}
            />
          </div>
          <div className="absolute w-full h-full z-[6] md:hidden lg:block reveal-up">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three "
              src={HomeOverlayElement1}
            />
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 md:top-0 md:bottom-0">
          <div className="h-full flex items-center max-w-[389px] lg:max-w-[400px] xl:max-w-[535px] [@media(min-width:1920px)]:max-w-[802.5px] IndexedUniversed-banner-caption md:pl-0 px-4">
            <div className="relative ">
              <div className="mb-4 text-[14px] md:text-[10.5px] xl:text-[14px] md:block hidden extra-para-vs">
                {translations.indexaBannerSubtitle}
              </div>
              <h1 className="md:mb-4 mb-2 md:leading-[33px] xl:leading-[44px] [@media(min-width:1920px)]:leading-[66px] text-[1.25rem] leading-[1.5rem] md:text-[30px] xl:text-[40px] [@media(min-width:1920px)]:text-[60px] font-semibold tracking-[-0.5px] md:tracking-[-0.6px] xl:tracking-[-0.8px] [@media(min-width:1920px)]:tracking-[-1.2px] reveal-up">
                {translations.indexaBannerHeading}
              </h1>
              <p className="mb-4 text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-normal leading-normal [@media(min-width:1920px)]:leading-[33px] [@media(min-width:1920px)]:text-[21px] worldclstext max-w-[389px] lg:max-w-[366px] xl:max-w-[488px] [@media(min-width:1920px)]:max-w-[732px] reveal-up extra-para-vs">
                {translations.indexaBannerDescription}
              </p>
              <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold md:hidden block">
                <div className="flex space-x-3 text-white items-center">
                  <div
                    onClick={scrollToContent} // Attach scroll handler
                    className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  >
                    <img
                      src={ArrowDown}
                      alt="Scroll down arrow"
                      className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                    />
                  </div>
                  <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                    {translations.aboutUsBannerButton}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 bottom-16 md:block hidden">
          <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold">
            <div className="flex space-x-3 text-white items-center">
              <div
                onClick={scrollToContent} // Attach scroll handler
                className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
              >
                <img
                  src={ArrowDown}
                  alt="Scroll down arrow"
                  className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                />
              </div>
              <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                {translations.aboutUsBannerButton}
              </span>
            </div>
          </div>
        </div>
      </section>

      <section
        className="indexa-pro py-12 lg:py-32 md:py-[8rem]"
        ref={scrollToRef}
      >
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap gap-8">
            <div className="lg:w-[45%] w-full flex items-center">
              <div className="lg:pl-0 px-4">
                <p className="text-sm text-gray-600 mb-1 learnmoreacc  md:hidden block">
                  Universal Products
                </p>
                <h2 className="md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] text-[24px] leading-[28px] tracking-tight font-semibold lg:max-w-[400px] how-indexa-title reveal-up">
                  {translations.title_how_indexa_works}
                </h2>
                <div className="lg:mt-[10rem] mt-4 lg:max-w-[470px]">
                  <p className="mb-4 text-justify font-mobile-14 text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] extra-para-vs reveal-up reveal-delay-2">
                    {translations.how_indexa_worksDesc1}
                  </p>

                  <p
                    className="text-justify font-mobile-14 text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] extra-para-vs reveal-up reveal-delay-3"
                    dangerouslySetInnerHTML={{
                      __html: translations.how_indexa_worksDesc2,
                    }}
                  ></p>
                </div>
              </div>
            </div>
            <div className="lg:w-[55%] w-full">
              <div className="flex items-center justify-center">
                <div className="max-w-[200px] flex flex-col lg:px-0 px-4 how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between my-20 animate__animated animate__fadeInLeft">
                    <div>
                      <div className="b-icon  mb-4">
                        <img src={BenefitsIcon1} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.premiums_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.premiums_info}
                      </p>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between  my-20 animate__animated animate__fadeInLeft">
                    <div>
                      <div className="b-icon mb-4">
                        <img src={BenefitsIcon2} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.interest_title}
                      </h3>
                    </div>
                    <div>
                      <img
                        className="min-w-[27px] ml-4"
                        src={BenefitsleftArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                  </div>
                </div>
                <div className="mx-4 relative animate__animated animate__zoomIn how-idexa-image">
                  <img className="hidden lg:block" src={BenefitsImage} alt="" />
                  <img
                    className="block lg:hidden"
                    src={BenefitsMobileImage}
                    alt=""
                  />
                  <div
                    className="flex justify-center flex-col lg:min-w-[160px] xl:min-w-[215px] min-w-[150px] items-center lg:p-3 xl:p-5 p-2.5 rounded-full bg-white absolute top-[50%] lg:left-[-75px] xl:left-[-100px] left-[-100px] account-value-div"
                    style={{ boxShadow: "4px 3px 13.5px rgb(0 0 0 / 12%)" }}
                  >
                    <img
                      className="md:mb-2 mb-1 md:w-[30px] lg:w-[22px] xl:w-[30px] w-[18px]"
                      src={AccountValueIcon}
                      alt=""
                    />
                    <p className="font-semibold md:text-[14px] xl:text-[18px] text-[12px] md:leading-[18px] xl:leading-[22px] leading-[17px] tracking-tight">
                      {translations.account_value}
                    </p>
                  </div>
                </div>
                <div className="max-w-[200px] flex flex-col how-indexa-pro-col">
                  <div className="benefits-grid flex items-center justify-between my-16 animate__animated animate__fadeInRight">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon mb-4 ">
                        <img src={BenefitsIcon3} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.monthly_deductions_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.monthly_deductions_info}
                      </p>
                    </div>
                  </div>
                  <div className="benefits-grid flex items-center justify-between my-16 animate__animated animate__fadeInRight">
                    <div>
                      <img
                        className="min-w-[27px] mr-4"
                        src={BenefitsRightArrowIcon}
                        alt="Benefits Icon"
                      />
                    </div>
                    <div>
                      <div className="b-icon mb-4 ">
                        <img src={BenefitsIcon4} alt="Benefits Icon" />
                      </div>
                      <h3 className="md:text-[12px] xl:text-[1rem] text-[12px] font-semibold mb-2 tracking-tight md:leading-[16px] xl:leading-[20px] leading-[14px] extra-para-vs">
                        {translations.other_deductions_title}
                      </h3>
                      <p className="md:!text-[10px] md:leading-[14px] xl:!text-[13px] xl:leading-[20px] tracking-tight hidden lg:block extra-para-vs">
                        {translations.other_deductions_info}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex pt-[1.5rem] animate__animated animate__fadeInLeft block lg:hidden">
                <div className="px-4">
                  <h3 className="font-semibold mb-1 text-[16px]">Premiums</h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Minus the premium expense charge as shown on the policy
                    schedule.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Monthly deductions
                  </h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4 border-b border-solid border-[#C6C4C4]">
                    (Including an administrative fee, cost of insurance for the
                    policy, front-eMay include an administrative fee, cost of
                    insurance for the policy, front-end load, charge per $1.000
                    of specified amount, and rider charges.nd load, if any, any
                    riders, and a charge per $1.000 of specified amount.)
                  </p>
                  <h3 className="font-semibold mb-1 text-[16px]">
                    Other deductions
                  </h3>
                  <p className="text-[14px] leading-[22px] mb-4 pb-4">
                    (Including any partial surrenders and partial surrender
                    charges.)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="indexed-account py-[4rem] lg:py-[12rem] md:py-[8rem] bg-[#F7F6F2]">
        <div className="container">
          <div className="flex lg:flex-nowrap flex-wrap items-center ">
            <div className="lg:w-1/3 w-full reveal-up lg:pl-0 pl-4">
              <div className="lg:max-w-[282px] md:max-w-[320px] sm:max-w-[200px] indexed-account-header">
                <h2 className="text-[24px] md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] leading-[28px] font-bold mb-2 extra-title-heading">
                  {translations.fixed_and_indexed_accounts}
                </h2>
              </div>
            </div>
            <div className="lg:w-2/3 w-full">
              <div className="flex lg:mt-0 mt-16 lg:justify-center overflow-x-auto whitespace-nowrap gap-8">
                <div className="lg:w-1/2 px-4 min-w-[230px] whitespace-normal indexed-account-grid">
                  <div className="reveal-up reveal-delay-1">
                    <div className="flex-none mb-4">
                      <img src={FixedAccountIcon} className=" w-[65px]" />
                    </div>
                    <div className="">
                      <h3 className="md:text-[18px] xl:text-[24px] text-[18px] font-semibold mb-2.5 md:leading-[22px] xl:leading-[28px] leading-[22px] tracking-tight extra-title36">
                        {translations.fixed_account_title}
                      </h3>
                      <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 extra-para-vs">
                        {translations.fixed_account_description}
                      </p>
                      <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] extra-para-vs">
                        {translations.fixed_account_benefits}
                        <br />
                        {translations.fixed_account_stable_interest} <br />
                        {translations.fixed_account_lower_risk}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2 px-4 min-w-[230px] whitespace-normal indexed-account-grid">
                  <div className="reveal-up reveal-delay-2">
                    <div className="flex-none mb-4">
                      <img src={IndexedAccountIcon} className=" w-[65px]" />
                    </div>
                    <div className="">
                      <h3 className="md:text-[18px] xl:text-[24px] text-[18px] font-semibold mb-2.5 md:leading-[22px] xl:leading-[28px] leading-[22px] tracking-tight extra-title36">
                        {translations.indexed_account_title}
                      </h3>
                      <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 extra-para-vs">
                        {translations.indexed_account_description}
                      </p>
                      <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] extra-para-vs">
                        {translations.indexed_account_benefits}
                        <br /> {translations.indexed_account_higher_growth}
                        <br /> {translations.indexed_account_higher_risk}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id=""
        className="indexed-account-section py-12 lg:py-32 overflow-hidden"
      >
        <div className="container">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Left text column */}
            <div className="w-full lg:w-2/5">
              <div className="reveal-up mb-10 lg:mb-8 [@media(min-width:1920px)]:mb-12 indexa-universal-header">
                <div className="text-[14px] leading-[19.6px] tracking-[-0.28px] text-gray-600 mb-2 lg:mb-4 learnmoreacc">
                  {translations.indexed_universal_product}
                </div>
                <div
                  className="text-[24px] leading-[28px] tracking-[-0.48px] md:text-[30px] md:leading-[33px] md:tracking-[-0.6px] xl:text-[40px] xl:leading-[44px] xl:tracking-[-0.8px] extra-title-heading"
                  dangerouslySetInnerHTML={{
                    __html: translations.indexed_account_title2,
                  }}
                ></div>
              </div>
              {/* Mobile image — capsule extends past the right viewport edge on mobile, full oval at tablet */}
              <div className="block lg:hidden -mr-4 md:mr-0 md:pl-4 mb-10 reveal-up flex md:max-w-[664px] overflow-hidden md:overflow-visible">
                <img
                  src={IndexedUniversalProductImage}
                  alt="Indexed Account"
                  className="w-[130%] md:w-full max-w-none h-auto"
                />
              </div>
              <div className="md:max-w-[506px] lg:max-w-[506px] indexa-universal-content">
                <p
                  className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] mb-4 pb-4 border-b border-solid border-[#D7CCB0] reveal-up reveal-delay-1 extra-para-vs"
                  dangerouslySetInnerHTML={{
                    __html: translations.indexed_account_description2,
                  }}
                ></p>
                <p
                  className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] mb-4 pb-4 border-b border-solid border-[#D7CCB0] reveal-up reveal-delay-2 extra-para-vs"
                  dangerouslySetInnerHTML={{
                    __html: translations.participation_rate_description,
                  }}
                ></p>
                <p
                  className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] mb-4 pb-4 border-b border-solid border-[#D7CCB0] reveal-up reveal-delay-3 extra-para-vs"
                  dangerouslySetInnerHTML={{
                    __html: translations.floor_description,
                  }}
                ></p>
              </div>
            </div>
            {/* Right image column — capsule extends past viewport per design */}
            <div className="w-full lg:w-3/5 hidden lg:block">
              <img
                src={IndexedAccountCoverImage}
                alt="Indexed Account"
                className="w-full lg:!max-w-none lg:w-[140%] [@media(min-width:1920px)]:w-[130%] h-auto object-cover reveal-up"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="Improve-protection pb-[6.5rem]">
        <div className="conntainer-fluid px-16 pl-4 pr-0">
          <div className="lg:pr-0 pl-4">
            <p className="text-[14px] text-black mb-1 md:hidden block">
              Universal Products
            </p>
            <h2
              className="md:text-center md:text-[24px] md:leading-[28px] xl:text-[1.8rem] xl:leading-[2.8rem] text-[24px] leading-[28px] mb-10 tracking-tight extra-title-heading"
              dangerouslySetInnerHTML={{
                __html: translations.indexaBenefits.improve_protection,
              }}
            ></h2>
          </div>
          <ul className="flex lg:justify-center overflow-auto improve-protection-uline whitespace-nowrap lg:mb-[5rem] lg:pr-0 pl-3">
            {listItems.map((item, index) => (
              <motion.li
                key={index}
                initial={{
                  opacity: 0,
                  transform: `translate(0%, ${item.y}) rotate(${item.rotate}deg)`,
                }}
                whileInView={{
                  opacity: 1,
                  transform: "translate(0%, 0%) rotate(0deg)",
                }}
                transition={{
                  delay: index * 0.2,
                  duration: 0.5,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
                className="lg:px-2.5 px-1 lg:w-[270px] min-w-[208px] whitespace-normal improve-protection-grid"
              >
                <div
                  className={`${item.bgColor} rounded-full md:px-5 px-3 md:py-24 h-full pt-16 pb-10`}
                >
                  <div className="min-h-[51px] mb-7 flex">
                    <img
                    src={item.icon}
                    className=" hidden lg:block"
                    alt=""
                  />
                  <img
                    src={item.mobileIcon}
                    className="block lg:hidden"
                    alt=""
                  />
                  </div>
                  <h3 className="md:text-[14px] xl:text-[18px] text-[14px] md:leading-[18px] xl:leading-[22px] leading:[20px] font-semibold mb-4 text-[#000000] min-h-[68px] ">
                    {item.heading}
                  </h3>
                  <p
                    className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-3 text-[#000000]"
                    dangerouslySetInnerHTML={{
                      __html: item.content || "",
                    }}
                  ></p>
                </div>
              </motion.li>
            ))}
          </ul>
          <div className="flex justify-center items-center hidden lg:flex">
            <h4 className="text-[24px] md:text-[18px] xl:text-[24px] font-semibold extra-title36">
              {translations.indexaBenefits.discover_more}
            </h4>
            <button className="bg-[#0D4248] hover:bg-[#0D4248] hover:text-[#ffffff] text-white font-bold rounded-full text-sm md:text-[10.5px] xl:text-sm px-5 text-center mb-0 gotofaqbtn ml-6 extra-btn-font">
              {translations.indexaBenefits.watch_video}
            </button>
          </div>
        </div>
      </section>

      <div className="hidden md:block">
        <FAQs />
      </div>
      <div className="block md:hidden">
        <FAQsMobile bgWhite={false} />
      </div>
      <HealthInsuranceHero />
    </>
  );
};

export default IndexedUniversalLifeInsurance;
